<div class="mat-dialog-camera-view">
    <div mat-dialog-title class="dialog-title">
        <h2 class="title-name">{{headTitle}}
            <span>
                <strong>Site Name : </strong>{{site_name}}
            </span>
        </h2>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <!-- Camera tables -->
        <div class="table-camera-view" *ngIf="!isVisibleTables">
            <table mat-table [dataSource]="dataSourceCamera" matSort matSortActive="created" matSortDisableClear
                matSortDirection="desc">

                <!-- unique_id Column -->
                <ng-container matColumnDef="unique_id">
                    <th mat-header-cell *matHeaderCellDef> Cam Unique ID </th>
                    <td mat-cell *matCellDef="let element; let i= index;"> {{element.camUniqueId}} </td>
                </ng-container>

                <!-- camera_id Column -->
                <!-- <ng-container matColumnDef="camera_id">
                    <th mat-header-cell *matHeaderCellDef> Camera Id </th>
                    <td mat-cell *matCellDef="let element"> {{element.cameraId}} </td>
                </ng-container> -->

                <!-- camera_name Column -->
                <ng-container matColumnDef="camera_name">
                    <th mat-header-cell *matHeaderCellDef> Camera Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.cameraName}} </td>
                </ng-container>

                <!-- camera_type Column -->
                <ng-container matColumnDef="camera_type">
                    <th mat-header-cell *matHeaderCellDef> Camera Type </th>
                    <td mat-cell *matCellDef="let element"> {{element.cameraType}} </td>
                </ng-container>

                <!-- site_name Column -->
                <ng-container matColumnDef="site_name">
                    <th mat-header-cell *matHeaderCellDef> Site Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.siteName}} </td>
                </ng-container>

                <!-- PTZ Column -->
                <!-- <ng-container matColumnDef="PTZ">
                    <th mat-header-cell *matHeaderCellDef> PTZ </th>
                    <td mat-cell *matCellDef="let element"> {{element.isPTZ}} </td>
                </ng-container> -->

                <!-- active Column -->
                <ng-container matColumnDef="active">
                    <th mat-header-cell *matHeaderCellDef> Active </th>
                    <td mat-cell *matCellDef="let element"> {{element.active}} </td>
                </ng-container>

                <!-- active Column -->
                <ng-container matColumnDef="analytic_name">
                    <th mat-header-cell *matHeaderCellDef> Analytic Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.analyticName}} </td>
                </ng-container>

                <!-- connected Column -->
                <ng-container matColumnDef="connected">
                    <th mat-header-cell *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.connected === true" matTooltip="Connected" class="up-status"></span>
                        <span *ngIf="element.connected === false" matTooltip="Not Connected" class="down-status"></span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsCamera"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCamera;">
                </tr>
            </table>
            <div class="no_record_found_msg" *ngIf="dataSourceCamera.data.length === 0">
                No Records Found!
            </div>
            <mat-paginator fixed [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSize" [length]="totalRecords"
                [pageIndex]="pageIndex" (page)="changePaging($event)" aria-label="Select page of users">
            </mat-paginator>
        </div>
        <!-- Device tables -->
        <div class="table-camera-view" *ngIf="isVisibleTables">
            <mat-grid-list cols="3" rowHeight="70px" class="header-grid">
                <mat-grid-tile class="select-device">
                    <mat-form-field appearance="outline" class="form-feild select-device-configuration">
                        <mat-label>Select Device Configuration </mat-label>
                        <mat-select name="selectDeviceConfiguration" [(ngModel)]="selectDeviceConfiguration"
                            (ngModelChange)="handleGetDeviceByClass()" [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let deviceConfig of deviceConfigurationList;"
                                value="{{deviceConfig.value}}">{{deviceConfig.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>
            </mat-grid-list>
            <!-- Device configuration Table -->
            <div class="mat-elevation-z8 table-pagination">
                <table mat-table [dataSource]="dataSourceDevice" class="mat-elevation-z8" matSort
                    matSortActive="created" matSortDisableClear matSortDirection="desc">

                    <!-- unique_id Column -->
                    <ng-container matColumnDef="deviceUniqueId">
                        <th mat-header-cell *matHeaderCellDef> Unique ID </th>
                        <td mat-cell *matCellDef="let element; let i= index;"> {{element.deviceUniqueId}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="deviceName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Device Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.deviceName}} </td>
                    </ng-container>

                    <!-- Device type Column -->
                    <ng-container matColumnDef="deviceType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Device Type </th>
                        <td mat-cell *matCellDef="let element"> {{element.deviceType}} </td>
                    </ng-container>

                    <!-- ip Column -->
                    <ng-container matColumnDef="ip">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> IP </th>
                        <td mat-cell *matCellDef="let element"> {{element.ip}} </td>
                    </ng-container>

                    <!-- username Column -->
                    <ng-container matColumnDef="username">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> User Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.username}} </td>
                    </ng-container>

                    <!-- device_class Column -->
                    <ng-container matColumnDef="device_class">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Device Class </th>
                        <td mat-cell *matCellDef="let element"> {{element.deviceClass}} </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-btn"
                                *ngIf="element.deviceClass === 'STROBE_DATA' || element.deviceClass === 'OUTPUT_DATA' ">
                                <button mat-raised-button class="test-outputs" (click)="testOutput(element)"
                                    matTooltip="{{element.deviceClass === 'STROBE_DATA' ? 'Test strobe' : 'Test output'}}">
                                    <mat-icon aria-hidden="false" aria-label="test strobe">notifications</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsDevice"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsDevice;">
                    </tr>
                </table>
                <div class="no_record_found_msg" *ngIf="dataSourceDevice.data.length === 0">
                    No Records Found!
                </div>
                <mat-paginator #devicePaginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSizeDevice"
                    [length]="totalRecordsDevice" [pageIndex]="pageIndexDevice" (page)="changePagingDevice($event)"
                    aria-label="Select page of users">
                </mat-paginator>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <!-- <button mat-stroked-button mat-dialog-close>Cancel</button> -->
        <button mat-stroked-button [mat-dialog-close]="true">Close</button>
    </mat-dialog-actions>
</div>